import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { NotesIcon, SidePanelList } from '@dreryk/react-components';

import { usePatientNoteQuery } from '~legacy.patient';

import { notesTranslationKeys } from '../../translations';
import { SidePanelLoader } from '../SidePanelLoader';

import { useCreateNoteListItems } from './NotesSidePanelList.hooks';

type NotesSidePanelListProps = { readonly patientId: PatientSimple['id'] };

const NotesSidePanelList = (props: NotesSidePanelListProps): JSX.Element => {
   const { data: noteData, loading: noteDataLoading } = usePatientNoteQuery(props.patientId);

   const noteListItems = useCreateNoteListItems(props.patientId, noteData);

   if (noteDataLoading) {
      return <SidePanelLoader />;
   }

   return <SidePanelList icon={<NotesIcon />} items={noteListItems} noItemsMessage={notesTranslationKeys.noNotes} />;
};

export { NotesSidePanelList };
